import * as React from 'react';
import { createContext, useContext, useState } from 'react';

import type { TrackingContextData } from 'js/lib/retracked';

import type { StaffManagementScopeData } from '../types/eventingTypes';

interface Props {
  targetUserId: number | string;
  ingressPointScopeData: StaffManagementScopeData;
  eventData: TrackingContextData | undefined; // could be undefined if the caller doesn't call Retracked properly
}

export interface StaffPermissionsEventingContext {
  ingressPointScopeData: StaffManagementScopeData | null;
  eventData: TrackingContextData | null | undefined;
  targetUserId: number | string | null;
  staffPermissionsViewLoadedTime: number | null;
  setStaffPermissionsViewLoadedTime: React.Dispatch<React.SetStateAction<number | null>>;
}

const INITIAL_CONTEXT_DATA: StaffPermissionsEventingContext = {
  ingressPointScopeData: null,
  eventData: null,
  targetUserId: null,
  staffPermissionsViewLoadedTime: null,
  setStaffPermissionsViewLoadedTime: () => undefined,
};

export const staffPermissionsEventingContext = createContext<StaffPermissionsEventingContext>(INITIAL_CONTEXT_DATA);

export type UseStaffPermissionsEventing = () => StaffPermissionsEventingContext;

export const useStaffPermissionsEventing: UseStaffPermissionsEventing = () =>
  useContext(staffPermissionsEventingContext);

export const StaffPermissionsEventing: React.LegacyFunctionComponentWithChildren<Props> = ({
  children,
  ingressPointScopeData,
  eventData,
  targetUserId,
}) => {
  const [staffPermissionsViewLoadedTime, setStaffPermissionsViewLoadedTime] = useState<number | null>(null);
  const { Provider } = staffPermissionsEventingContext;

  return (
    <Provider
      value={{
        ingressPointScopeData,
        eventData,
        targetUserId,
        staffPermissionsViewLoadedTime,
        setStaffPermissionsViewLoadedTime,
      }}
    >
      {children}
    </Provider>
  );
};
